import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App/App';
import reportWebVitals from './reportWebVitals';
import './assets/scss/main.scss';
import { BrowserRouter } from 'react-router-dom';
import { ModeEnum } from './model';

const selector = document.currentScript?.getAttribute('data-selector') || '#root';
let mode = document.currentScript?.getAttribute('data-mode') || 'full';

console.log('mode: ', mode);

if(!["full", "widget"].includes(mode)){
  mode = 'full';
}

let rootElement;
try {
  rootElement = document.querySelector(selector);
} catch (e) {
  rootElement = document.getElementById('root');
}
if (!rootElement) rootElement = document.getElementById('root');

console.log('rootElement: ', rootElement);
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App mode={mode as ModeEnum} />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  console.error('Can\'t render this app');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
